import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { Observable } from 'rxjs';
import { TOwnerReportHeader } from '../entities/owner-report-header.model';

/** HTTP of the gym owner's profile (personservice `OwnerProfileController`). */
@Injectable({ providedIn: 'root' })
export class OwnerProfileService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.personService;

  /**
   * The session tenant's identification for report headers. Open to any
   * authenticated user; always 200, with every field null when there is no
   * owner.
   */
  public getReportHeader(): Observable<TOwnerReportHeader> {
    return this.http.get<TOwnerReportHeader>(
      `${this.baseUrl}/OwnerProfile/ReportHeader`,
      {
        withCredentials: true,
      }
    );
  }
}
